export default __webpack_public_path__ + "ea2e2458c46826d35cf62ffaa06f9cf5.svg";